import { AGES } from './constants';
import { getAge } from '../../../Helpers/dates';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';

/**
 * Checks which age range an age falls into
 * @param {number} age - The age to check
 * @returns {string|null} The matching age range or null if not found
 */
export const getAgeRange = (age) =>
  age >= 18 && age <= 30
    ? AGES[0]
    : age >= 31 && age <= 45
      ? AGES[1]
      : age >= 46 && age <= 65
        ? AGES[2]
        : age > 65
          ? AGES[3]
          : null;

export default (data) => {
  if (!data) return {};
  const mappedData = { ...data };
  const contact = mappedData?.contacts?.find(
    ({ contactTypeId }) => contactTypeId === 1
  );
  const primaryAddress = contact?.contactAddresses?.find(
    ({ addressTypeId }) => addressTypeId === 1
  );
  const age = getAge(new Date(mappedData?.birthDate));
  return {
    customerName: mappedData?.firstName,
    customerSurname: mappedData?.lastName,
    fiscalCode: mappedData?.fiscalCode,
    gender: mappedData?.gender,
    deutscheBankCustomer: true,
    city: primaryAddress?.city,
    zipCode: primaryAddress?.zipCode,
    province: primaryAddress?.state,
    occupation: capitalize(contact?.occupation),
    company: mappedData?.employeer,
    age: age ? getAgeRange(age) : null,
  };
};
